import Vue from 'vue'

Vue.filter('capitalize', function (val) {
  if (val)
  {
    return val.charAt(0).toUpperCase() + val.slice(1);
  }
  return ''
})